module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/nomination-day-centres-open.jpg?v=ad19b9ab";